import React from "react";
import { Flex, Heading } from "@chakra-ui/react";
import PairSelect from "src/component/PairSelect/PairSelect";
import ExchangeSelect from "src/component/ExchangeSelect/ExchangeSelect";
import AccountSelect from "src/component/AccountSelect/AccountSelect";
import TradingViewWidget from "src/component/TradingViewWidget";
import { useExchangeInfoStore } from "src/store";
import { getPairSymbol, getTradingviewCexName } from "src/store/utils";
import { TradeType } from "src/api/types";

const KLine = () => {
  const { selectedExchangeKey, selectedSpotPair: selectedPair } = useExchangeInfoStore();

  // TradingView配置，显示K线详细数据
  const tradingViewConfig = {
    details: true,
    show_popup_button: true,
    withdateranges: true,
    studies: [
      "Volume@tv-basicstudies", // 成交量指标
      "MASimple@tv-basicstudies", // 简单移动平均线
    ],
    studies_overrides: {
      "volume.volume.color.0": "rgba(255, 0, 0, 0.5)",
      "volume.volume.color.1": "rgba(0, 255, 0, 0.5)",
    },
    show_ohlc: true, // 显示OHLC数据
    show_high_low: true, // 显示24小时高低点
    show_24h_volume: true, // 显示24小时交易额
  };

  return (
    <Flex width="100%" flexDirection="column" p={4} gap={4}>
      {/* 交易对和交易所选择区域 */}
      <Flex
        width="100%"
        flexDirection={{ base: "column", md: "row" }}
        gap={4}
        mb={6}
        p={4}
        borderRadius="md"
        boxShadow="md"
        bg="whiteAlpha.200"
      >
        <Flex flex="1" alignItems="center" gap={2}>
          <PairSelect tradeType={TradeType.SPOT} />
        </Flex>
        <Flex flex="1" alignItems="center" gap={2}>
          <ExchangeSelect tradeType={TradeType.SPOT} />
        </Flex>
        <Flex flex="1" alignItems="center" gap={2}>
          <AccountSelect />
        </Flex>
      </Flex>

      {/* K线图区域 */}
      <Flex
        width="100%"
        height="calc(100vh - 300px)"
        minHeight="500px"
        borderRadius="md"
        boxShadow="lg"
        overflow="hidden"
      >
        {selectedPair && selectedExchangeKey ? (
          <TradingViewWidget
            pairName={getPairSymbol(selectedPair.base, selectedPair.quote)}
            cexName={getTradingviewCexName(selectedExchangeKey)}
            isPerpetual={false}
            config={tradingViewConfig}
          />
        ) : (
          <Flex width="100%" height="100%" justifyContent="center" alignItems="center" bg="whiteAlpha.100">
            请选择交易对和交易所
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default KLine;
